<template>
  <section class="test-upload">
    <header class="test-upload__header">
      <WTitle size="xsmall"> Salvar arquivo como </WTitle>

      <WButton
        icon="icCheckOutlined"
        size="small"
        :disabled="!isValid || loading"
        :loading="loading"
        variant="cta"
        @click="upload"
      >
        Salvar arquivo
      </WButton>

      <WButton
        icon="icClose"
        size="small"
        icon-button
        variant="tertiary"
        @click="close"
      />
    </header>

    <form class="test-upload__form" @submit.prevent>
      <HTextfield
        v-model:value="form.name"
        label="Nome"
        placeholder="Nome do exame"
      />

      <HTextfield
        v-model:value="form.date"
        label="Data de realização"
        placeholder="Nome do exame"
        type="date"
      />
    </form>

    <img
      v-if="filePreview"
      alt="preview-file"
      class="test-upload__preview"
      :src="filePreview.url"
    />
  </section>
</template>

<script>
import { WButton, WTitle } from '@alice-health/wonderland-vue'
import parse from 'date-fns/parse'
import { mapGetters } from 'vuex'

import { HTextfield } from '@/components/shared/atoms'
import Logger, { EventModel, EventName } from '@/wrappers/logger'

export default {
  components: { WButton, WTitle, HTextfield },
  props: {
    channelId: { type: String, default: undefined },
    channelPersonId: { type: String, default: undefined },
    messageId: { type: String, default: undefined },
    file: { type: String, default: undefined }
  },
  data() {
    return {
      filePreview: '',
      form: {
        name: '',
        date: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters('member', ['getMemberById']),
    isValid() {
      return this.form.name && this.form.date
    }
  },
  created() {
    this.getFilePreview()
  },
  methods: {
    close(shouldTrack = true) {
      if (shouldTrack) {
        this.track({ context: 'test_result_modal', action: 'close' })
      }

      this.$store.commit('ui/channel/toggleTestResultModal')
    },
    track(data) {
      Logger.addLog(EventName.USER_INTERACTION_MESSAGE, {
        model: EventModel.CHANNELS,
        data
      })
    },
    async upload() {
      this.loading = true

      const personId = this.getMemberById({
        channelPersonId: this.channelPersonId
      })?.id

      await this.$store.dispatch(
        'laboratoryTestUploadResults/createTestResultFile',
        {
          personId,
          performedAt: parse(this.form.date, 'yyyy-MM-dd', new Date())
            .toISOString()
            .replace('Z', ''),
          description: this.form.name,
          file: {
            ...this.filePreview,
            fileName: this.form.name,
            url: this.file
          }
        }
      )

      this.track({ context: 'test_result_modal', action: 'save' })

      this.close(false)
    },
    async getFilePreview() {
      const responseData = await this.$store.dispatch('file/getFile', this.file)
      this.filePreview = responseData
    }
  }
}
</script>

<style lang="scss" scoped>
.test-upload {
  background: var(--gl-color-shades-white);
  height: 100%;
  height: calc(100% - var(--filter-header-height));
  overflow: auto;
  padding: var(--gl-spacing-04);
  top: var(--top);
  width: 100%;
  &__header {
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
  }

  &__form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--gl-spacing-04);
    margin: var(--gl-spacing-04) 0;
  }

  &__preview {
    max-height: calc(100% - 134px);
    margin: auto;
  }
}
</style>
